import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type CreateDeviceApiResponse } from '../services/createDeviceService'

export interface CreateDeviceState {
  isLoading: boolean
  error: string | undefined
  data: CreateDeviceApiResponse | undefined
  httpStatus: number | undefined
}

export const initialState: CreateDeviceState = {
  isLoading: false,
  error: undefined,
  data: undefined,
  httpStatus: 0
}

const createDeviceSlice = createSlice({
  name: 'CreateDeviceSlice',
  initialState,
  reducers: {
    createDeviceLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        data: undefined,
        httpStatus: 0
      }
    },
    createDeviceUpdateAction: (state, action: PayloadAction<{ data: CreateDeviceApiResponse, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    createDeviceErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        data: undefined,
        httpStatus: action.payload.httpStatus
      }
    },
    reset: () => initialState
  }
})

export const {
  createDeviceLoadingAction,
  createDeviceUpdateAction,
  createDeviceErrorAction,
  reset
} = createDeviceSlice.actions

export default createDeviceSlice.reducer
